import type { FilterConfig } from '#types/config/components/filter'

export default {
  height: '6rem',
  width: '4.5rem'
} satisfies FilterConfig['option']['tileImage']
